import * as THREE from 'three';
import { useMemo, useRef, useLayoutEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import boldUrl from './Roboto Black_Regular.json';
import { Text3D } from '@react-three/drei';

export default function FiberText({ children, vAlign = 'right', hAlign = 'right', size = 1.5, color = 'white', rotation = [0, 0, 0], billboard = true, ...props }) {
  const config = useMemo(
    () => ({
      size: props?.size || 2,
      height: props?.height || 0.1, // thinner depth looks better
      curveSegments: 8, // ✅ smooth curves
      bevelEnabled: true, // ✅ optional subtle bevel
      bevelThickness: 0.02,
      bevelSize: 0.02,
      bevelOffset: 0,
      bevelSegments: 2 // ✅ small roundness
    }),
    []
  );
  const mesh = useRef();

  useLayoutEffect(() => {
    if (!mesh.current?.geometry?.boundingBox) return;

    const size = new THREE.Vector3();
    mesh.current.geometry.computeBoundingBox();
    mesh.current.geometry.boundingBox.getSize(size);

    mesh.current.position.set(hAlign === 'center' ? -size.x / 2 : hAlign === 'right' ? 0 : -size.x, vAlign === 'center' ? -size.y / 2 : vAlign === 'top' ? 0 : -size.y, 0);
  }, [children, hAlign, vAlign]);

  useFrame(({ camera }) => {
    if (billboard && mesh.current) {
      mesh.current.parent.quaternion.copy(camera.quaternion);
    }
  });

  return (
    <group {...props} scale={[0.1 * size, 0.1 * size, 0.1 * size]} rotation={rotation}>
      <Text3D ref={mesh} font={boldUrl} {...config}>
        {children}
        <meshPhongMaterial color={color} shininess={100} specular={'#333'} emissive={'#111'} emissiveIntensity={0.05} />
      </Text3D>
    </group>
  );
}
